import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { canRenderComponent } from "../../utils/common";
import { COMPONENTS } from "../../constants/component";
import ProfileList from "../../components/Table/ProfileList";

const AdminProfile = () => {
  const authorizedComponent = useSelector(
    (state) => state.authentication.authorized_components
  );
  const [authorizedProfile, setAuthorizedProfile] = useState(
    canRenderComponent(COMPONENTS.PROFILE_DISPLAY)
  );

  useEffect(() => {
    return () => {
      setAuthorizedProfile(canRenderComponent(COMPONENTS.PROFILE_DISPLAY));
    };
  }, [authorizedComponent]);

  return authorizedProfile && <ProfileList />;
};
export default AdminProfile;
